import { useMutation } from '@tanstack/react-query';

import { put } from '@truefit/http-utils';
import type { CloudUser } from '@c360/types';
import getCurrentUser from './getCurrentUser';

const useUpdateUser = () => {
  const getCurrentUserQuery = getCurrentUser();
  return useMutation({
    mutationFn: async (user: Partial<CloudUser>) => {
      const response = await put<CloudUser>('/v1.0/user', { ...user });
      return response.data;
    },
    onSuccess: () => {
      getCurrentUserQuery.refetch();
    },
  });
};

export default useUpdateUser;
